import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter, } from '@mui/x-data-grid-pro';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
const DataGridToolbar = ({ showSearch, quickFilterProps }) => {
    return (_jsxs(GridToolbarContainer, { sx: { justifyContent: 'space-between' }, children: [_jsxs(Box, { children: [_jsx(GridToolbarColumnsButton, {}), _jsx(GridToolbarFilterButton, {})] }), showSearch && _jsx(GridToolbarQuickFilter, Object.assign({ debounceMs: 700 }, quickFilterProps))] }));
};
DataGridToolbar.defaultProps = {
    showSearch: true,
};
DataGridToolbar.propTypes = {
    showSearch: PropTypes.bool,
    quickFilterProps: PropTypes.object,
};
export default DataGridToolbar;
